import Image from "@/components/Image";
import { TrackerA } from "@/components/Tracker";
import { getDeliveryDetail } from "@/services";
import { useEffect, useState } from "react";
import styles from "./index.module.less";

export default function AdIcon() {
  const [adData, setAdData] = useState(null);

  useEffect(() => {
    let isMounted = true;

    getDeliveryDetail("web-header-ad-icon")
      .then((res) => {
        // interface IADData {
        //   img: "https://gaoding-market-fat.dancf.com/market-operations/market/side/b984c42766d64261a31ce4d14d4ec660/1763002326725.png";
        //   link: "https://www.gaoding.com/";
        // }
        const pitModule = res?.pit_modules?.[0];
        const data = {
          id: pitModule.module_id,
          title: pitModule.module_name,
          ...(pitModule?.material || {}),
        };

        if (isMounted && data) {
          setAdData(data);
        }
      })
      .catch(() => {
        // 静默处理错误，不显示广告
      });

    return () => {
      isMounted = false;
    };
  }, []);

  // 如果没有广告数据，不显示
  if (!adData || !adData.img || !adData.link) {
    return null;
  }

  return (
    <TrackerA
      className={styles.headerItem}
      href={adData.link}
      target="_blank"
      rel="nofollow noreferrer"
      data-gd-expose="resource_loc_expose"
      data-gd-click="resource_loc_click"
      data-module-name="顶部导航栏"
      data-subject-name="资源位"
      data-resource-id={adData.id || ""}
      data-resource-title={adData.title || "顶部运营位置广告"}
    >
      <Image
        src={adData.img}
        alt="运营广告"
        width={24}
        height={24}
        loading="eager"
      />
    </TrackerA>
  );
}
